import React from 'react';

const Section = ({ 
  children, 
  id,
  className = '', 
  background = 'white',
  paddingY = 'py-20',
  ...props 
}) => {
  const backgroundStyles = {
    white: 'bg-white',
    light: 'bg-lightgray',
    primary: 'bg-primary text-white',
    secondary: 'bg-secondary text-white',
    accent: 'bg-accent bg-opacity-20',
    gradient: 'bg-gradient-to-br from-lightgray to-white',
  };
  
  return (
    <section 
      id={id}
      className={`${paddingY} ${backgroundStyles[background]} ${className}`}
      {...props}
    >
      <div className="container mx-auto px-6">
        {children}
      </div>
    </section>
  );
};

export const SectionTitle = ({ 
  children, 
  className = '', 
  centered = true,
  size = 'lg',
  marginBottom = 'mb-10',
  ...props 
}) => {
  const sizeStyles = {
    sm: 'text-2xl',
    md: 'text-3xl',
    lg: 'text-4xl',
    xl: 'text-5xl',
  };
  
  const alignmentStyles = centered ? 'text-center' : 'text-left';
  
  return (
    <h2 
      className={`font-bold text-primary ${sizeStyles[size]} ${alignmentStyles} ${marginBottom} ${className}`}
      {...props}
    >
      {children}
    </h2>
  );
};

export const SectionSubtitle = ({ 
  children, 
  className = '', 
  centered = true,
  marginBottom = 'mb-16',
  ...props 
}) => {
  const alignmentStyles = centered ? 'text-center' : 'text-left';
  
  return (
    <p 
      className={`text-lg text-gray-700 ${alignmentStyles} max-w-3xl ${centered ? 'mx-auto' : ''} ${marginBottom} ${className}`}
      {...props}
    >
      {children}
    </p>
  );
};

export default Section;